export type AccountCategory =
  | 'checking'
  | 'savings'
  | 'investment'
  | 'retirement'
  | 'real_estate'
  | 'other_asset'
  | 'credit_card'
  | 'student_loan'
  | 'medical_debt'
  | 'personal_loan'
  | 'auto_loan'
  | 'mortgage'
  | 'other_liability';

export type AssetAccountCategory = Extract<
  AccountCategory,
  'checking' | 'savings' | 'investment' | 'retirement' | 'real_estate' | 'other_asset'
>;

export type LiabilityAccountCategory = Extract<
  AccountCategory,
  'credit_card' | 'student_loan' | 'medical_debt' | 'personal_loan' | 'auto_loan' | 'mortgage' | 'other_liability'
>;

export type AccountRisk = 'healthy' | 'caution' | 'risk' | 'neutral';

export type AccountInsightSeverity = 'info' | 'warn' | 'danger';

export interface AssetAccount {
  id: string;
  name: string;
  institution: string;
  last4: string;
  category: AssetAccountCategory;
  balance: number;
  ytdChangeDollar: number;
  ytdChangePct: number;
  lastUpdated: string;
}

export interface LiabilityAccount {
  id: string;
  name: string;
  institution: string;
  last4: string;
  category: LiabilityAccountCategory;
  balance: number;
  apr: number | null;
  creditLimit: number | null;
  utilization: number | null;
  minPayment: number | null;
  ytdChangeDollar: number;
  ytdChangePct: number;
  lastUpdated: string;
  risk: AccountRisk;
}

export interface AccountTrendPoint {
  month: string;
  assets: number;
  liabilities: number;
  netWorth: number;
}

export interface AccountInsight {
  id: string;
  icon: string;
  title: string;
  body: string;
  severity: AccountInsightSeverity;
}

export interface ClientAccountsState {
  assets: AssetAccount[];
  liabilities: LiabilityAccount[];
  trends: AccountTrendPoint[];
  insights: AccountInsight[];
}
